const STORAGE_KEY = 'bm.soundOffered';

/**
 * Ob der Ton schon einmal angeboten wurde.
 *
 * Der Ton ist bewusst standardmäßig aus (GDD Mobile-Härtung) und liegt im Menü
 * hinter drei Taps — praktisch findet ihn deshalb niemand, obwohl er genau das
 * Problem löst, dass das Handy während der Diskussion auf dem Tisch liegt. Ein
 * einmaliges Angebot in der Lobby ist der einzige Moment, in dem dafür Ruhe ist.
 *
 * Wie `recentName` bewusst im `localStorage`: Die Frage soll auch einen neuen
 * Raum und einen Neustart überleben — zweimal gefragt ist einmal zu oft.
 */
export function wasSoundOffered(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    // Gesperrter Speicher: dann lieber jedes Mal fragen als nie.
    return false;
  }
}

export function markSoundOffered(): void {
  try {
    localStorage.setItem(STORAGE_KEY, 'true');
  } catch {
    // Kostet nur den Komfort, nicht die Funktion.
  }
}
